export default __webpack_public_path__ + "static/23-0747cfc949d4512dc761b92ac58dc743.webp";